const defaultUnique = (e) => e;

export const unique = (array, selector) => {
  selector = selector || defaultUnique;
  const keys = new Set();
  return array.filter(
    (el) => !keys.has(selector(el)) && keys.add(selector(el)),
  );
};
